<template>
  <div :id="page.about.$path" v-if="page.about" :class="{'active': currentPage == page.about.$path}">
    <div class="section section_about">
      <div class="section__main reduced-width">
        <Tabs :content="[{text: page.about.company, comp: firstTab}, {text: page.about.strategy, comp: secondTab}, {text: page.about.investors, comp: thirdTab}, {text: page.about.whyelbruscapital, comp: fourthTab}]"></Tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AboutCompany from '@/pages/AboutCompany';
import AboutStrategy from '@/pages/AboutStrategy';
import AboutInvestors from '@/pages/AboutInvestors';
import WhyElbrusCapital from '@/pages/WhyElbrusCapital';
import Tabs from '@/components/Tabs';

export default {
  name: 'about',
  data() {
    return {
      firstTab: AboutCompany,
      secondTab: AboutStrategy,
      thirdTab: AboutInvestors,
      fourthTab: WhyElbrusCapital,
    };
  },
  computed: mapGetters({
    lang: 'lang',
    page: 'page',
    currentPage: 'currentPage',
  }),
  components: {
    Tabs,
    AboutCompany,
    AboutStrategy,
    AboutInvestors,
    WhyElbrusCapital,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @keyframes rotateCircles {
    0% {
      transform: rotateX(0) rotateY(0) rotateZ(0);
    }
    100% {
      transform: rotateX(360deg) rotateY(360deg) rotateZ(360deg);
    }
  }

  #about {
    min-height: 50vh;
  }
  .section {
    &_about {
      padding-top: 120px;
      margin-top: 100vh;

      .section__main {
        z-index: 2;
        padding-top: 0;
      }
    }
  }
  .cols_company {
    & + .cols_company {
      margin-top: 80px;
    }
  }
  .company-circle {
    position: relative;

    &_1 {
      height: 160px;
    }

    &_2 {
      height: 240px;
    }

    .circles {
      top: -20px;
      left: 50%;
      position: absolute;
      text-align: center;
      transform: translateX(-50%);

      &:before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        height: 100%;
      }

      &__container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        transform-style: preserve-3d;

        .static & {
          animation: none !important;
        }

        .circle {
          position: absolute;
          transform-style: preserve-3d;
          border-radius: 100%;
          border: 2px solid $main-color;

          &:before {
            transform: translateZ(-90px);
          }

          &:after {
            transform: translateZ(90px);
          }

          &:nth-child(1) {
            transform: rotateZ(72deg) rotateX(63.435deg);
          }

          &:nth-child(2) {
            transform: rotateZ(144deg) rotateX(63.435deg);
          }

          &:nth-child(4) {
            transform: rotateZ(360deg) rotateX(63.435deg);
          }
        }
      }

      &_1 {
        height: 160px;
        width: 160px;

        .circles__container {
          width: 160px;
          height: 160px;
          margin: 0 auto;
          animation: rotateCircles 20s infinite linear;

          .circle {
            width: 160px;
            height: 160px;

            &:nth-child(3) {
              transform: rotateZ(288deg) rotateX(63.435deg);
              background: rgba(238, 46, 34, 0.12);
              border: none;
            }

            &:nth-child(4) {
              border: 4px solid #ee2e22;
            }
          }
        }
      }

      &_2 {
        width: 240px;
        height: 240px;

        .circles__container {
          width: 240px;
          height: 240px;
          animation: rotateCircles 25s infinite linear forwards;

          .circle {
            width: 240px;
            height: 240px;

            &:nth-child(1) {
              border: 4px solid #ee2e22;
            }

            &:nth-child(3) {
              transform: rotateZ(216deg) rotateX(63.435deg);
              background: rgba(238, 46, 34, 0.12);
              border: none;
            }
          }
        }
      }
    }
  }

  @media (max-width: 850px) {
    .company-circle {
      &_1 {
        margin-top: 20px;
      }

      &_2 {
        margin-top: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/About.vue?1d19c9f3